import type { Notification, NotificationListRequest, NotificationListResponse } from './types';
import { get, post, request } from '@/utils/request';

// 通知相关API
export const notificationApi = {
  // 获取通知列表
  getNotificationList: (params?: NotificationListRequest) => {
    console.log('[notice] /system/notice/user/list params =>', params || {});
    return get<NotificationListResponse>('/system/notice/user/list', params);
  },

  // 根据ID获取通知详情
  getNotificationById: (id: string) => {
    return request.get<Notification>(`/api/notifications/${id}`);
  },

  // 标记通知为已读
  markAsRead: (id: string) => {
    return post('/system/notice/user/mark-read', [id]);
  },

  // 批量标记为已读
  batchMarkAsRead: (ids: string[]) => {
    return post('/system/notice/user/mark-read', ids);
  },

  // 标记所有通知为已读
  markAllAsRead: () => {
    return post('/system/notice/user/mark-all-read');
  },

  // 删除通知
  deleteNotification: async (id: string) => {
    const baseURL = import.meta.env.VITE_API_URL || import.meta.env.VITE_WEB_BASE_API || 'http://localhost:8080';
    const cleanBaseURL = baseURL.replace(/\/$/, '');
    const url = `${cleanBaseURL}/system/notice/user/batch`;

    try {
      const { useUserStore } = await import('@/stores');
      const userStore = useUserStore();
      const token = userStore.token || localStorage.getItem('token') || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxIiwicm5TdHIiOiJKSDBFSDhJTTR6Y2ZXODhhN1g0UUtZVzg3b01OQlBWYSIsInRlbmFudElkIjoiMDAwMDAiLCJ1c2VySWQiOjF9.mmhTQtmV8BO6-UDZl402DBb3Zg79DJKENeMwsdsKh2M';

      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify([id]),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { code: 200, msg: 'success', data: null };
    }
    catch (error) {
      console.error('删除通知失败:', error);
      throw error;
    }
  },

  // 批量删除通知
  batchDelete: async (ids: string[]) => {
    const baseURL = import.meta.env.VITE_API_URL || import.meta.env.VITE_WEB_BASE_API || 'http://localhost:8080';
    const cleanBaseURL = baseURL.replace(/\/$/, '');
    const url = `${cleanBaseURL}/system/notice/user/batch`;

    try {
      const { useUserStore } = await import('@/stores');
      const userStore = useUserStore();
      const token = userStore.token || localStorage.getItem('token') || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxIiwicm5TdHIiOiJKSDBFSDhJTTR6Y2ZXODhhN1g0UUtZVzg3b01OQlBWYSIsInRlbmFudElkIjoiMDAwMDAiLCJ1c2VySWQiOjF9.mmhTQtmV8BO6-UDZl402DBb3Zg79DJKENeMwsdsKh2M';

      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(ids),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { code: 200, msg: 'success', data: null };
    }
    catch (error) {
      console.error('批量删除通知失败:', error);
      throw error;
    }
  },

  // 删除所有通知
  deleteAll: async () => {
    const baseURL = import.meta.env.VITE_API_URL || import.meta.env.VITE_WEB_BASE_API || 'http://localhost:8080';
    const cleanBaseURL = baseURL.replace(/\/$/, '');
    const url = `${cleanBaseURL}/system/notice/user/all`;

    try {
      const { useUserStore } = await import('@/stores');
      const userStore = useUserStore();
      const token = userStore.token || localStorage.getItem('token') || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxIiwicm5TdHIiOiJKSDBFSDhJTTR6Y2ZXODhhN1g0UUtZVzg3b01OQlBWYSIsInRlbmFudElkIjoiMDAwMDAiLCJ1c2VySWQiOjF9.mmhTQtmV8BO6-UDZl402DBb3Zg79DJKENeMwsdsKh2M';

      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { code: 200, msg: 'success', data: null };
    }
    catch (error) {
      console.error('删除所有通知失败:', error);
      throw error;
    }
  },

  // 获取未读通知数量
  getUnreadCount: () => {
    return get<{ data: number }>('/system/notice/user/unread/count');
  },
};
